export default __webpack_public_path__ + "static/chat-outline-18755802134c56b3297b31a21c025fa4.svg";